import * as React from "react";
import styled from "styled-components";
import { Resources, useResource } from "Translations/Resources";

const StyledContent = styled.div`
  width: 100%;
  display: grid;
`;

type Props = {
  title: string;
};

export const UnauthenticatedLayout: React.FC<
  React.PropsWithChildren<Props>
> = props => {
  const { t } = useResource();
  const { title } = props;

  React.useEffect(() => {
    document.title = `${title} | ${t(Resources.Common.AppName)}`;
  }, [title, t]);

  return (
    <StyledContent>
      <div>{props.children}</div>
    </StyledContent>
  );
};
